import type { BrowserCacheResourceConfig } from "@pp/core/src/controllers/browserCacheController/types";
import { getStaticResourceUrl } from '@pp/core/src/utils/getStaticBaseUrl';

export const resources: BrowserCacheResourceConfig = {
  CUSTOM: { url: getStaticResourceUrl('assets/fonts/Poppins-Bold.woff2'), priority: 'block', kind: 'font' } /* game custom */,
};
